<header class="header-route">
  <img
    src="/assets/icons/arrow-left.svg"
    [alt]="'COMMONS.EXIT' | i18nextEager"
    (click)="handleGoBack()"
    class="arrow"
  />
  <img src="/assets/icons/logo.svg" class="element" alt="{{ 'COMMONS.ACCIONA_LOGO' | i18nextEager }}" />
  <div class="container-title element">
    <h5>green energy</h5>
    <span class="separator"></span>
    <span class="subtitle">{{ 'HOME.NEW_CONTRACT' | i18nextEager | uppercase }}</span>
  </div>
  <div class="space"></div>
  <div
    *ngIf="tabIndex !== 0"
    class="icon"
    [ngClass]="{
      'margin-right': (fromOffer && tabIndex === 3) || (!fromOffer && tabIndex === 4)
    }"
  >
    <img
      [src]="'/assets/icons/progress-' + progress + '.svg'"
      [alt]="'COMMONS.PROGRESS' | i18nextEager"
      (click)="handleOpenProgress()"
      [ngClass]="{ 'cursor-pointer': tabIndex > 1 }"
    />
  </div>
  <button
    *ngIf="(fromOffer && tabIndex !== 3) || (!fromOffer && tabIndex !== 4)"
    (click)="handleGoNext()"
    [disabled]="!goNext"
    class="margin-right"
  >
    {{ 'COMMONS.NEXT' | i18nextEager }}
  </button>
</header>
<div
  class="new-contract-large-accounts__container"
  [ngClass]="{ 'new-contract-large-accounts__container--padding-stepper': tabIndex !== 0 }"
>
  <div class="new-contract-large-accounts__loader" *ngIf="isLoading">
    <app-loading [onlyIcon]="true"></app-loading>
    {{ 'COMMONS.LOADING' | i18nextEager }}
  </div>
  <mat-tab-group
    *ngIf="tabIndex !== 0"
    class="new-contract-large-accounts__stepper"
    [selectedIndex]="tabIndex - 1"
    [ngClass]="{ 'new-contract-large-accounts__stepper--three-tabs ': fromOffer }"
    (selectedTabChange)="tabChange($event)"
  >
    <mat-tab [aria-labelledby]="'active'" [disabled]="true">
      <app-new-contract-select-offer
        *ngIf="fromOffer && tabIndex === 1"
        (canGoNext)="handleCanGoNextTab1Offer($event)"
        (changeLoader)="handleChangeLoader($event)"
      ></app-new-contract-select-offer>
      <app-new-contract-select-values
        *ngIf="!fromOffer && tabIndex === 1"
        [codTradingAccount]="codTradingAccount"
        (canGoNext)="handleCanGoNextTab1Campaign($event)"
        (changeLoader)="handleChangeLoader($event)"
      ></app-new-contract-select-values
    ></mat-tab>
    <mat-tab
      [aria-labelledby]="tabIndex > 1 ? 'active' : null"
      [disabled]="fromOffer || (!fromOffer && tabIndex !== 3)"
    >
      <app-new-contract-hiring-data
        *ngIf="fromOffer && tabIndex === 2"
        (canGoNext)="handleCanGoNextHiring($event)"
        (changeLoader)="handleChangeLoader($event)"
      ></app-new-contract-hiring-data>
      <app-new-contract-data-offer
        *ngIf="!fromOffer && tabIndex === 2"
        [dataOffer]="dataOffer"
        [dataForms]="dataForms"
        (canGoNext)="handleCanGoNextTab2Campaign($event)"
        (changeLoader)="handleChangeLoader($event)"
      ></app-new-contract-data-offer>
    </mat-tab>
    <mat-tab [aria-labelledby]="tabIndex > 2 ? 'active' : null" [disabled]="true">
      <app-new-contract-sign
        *ngIf="fromOffer && tabIndex === 3"
        (changeLoader)="handleChangeLoader($event)"
        [dataForms]="dataForms"
        [idContract]="idContract"
        [fromOffer]="fromOffer"
      ></app-new-contract-sign>
      <app-new-contract-hiring-data
        *ngIf="!fromOffer && tabIndex === 3"
        (canGoNext)="handleCanGoNextHiring($event)"
        (changeLoader)="handleChangeLoader($event)"
      ></app-new-contract-hiring-data>
    </mat-tab>
    <mat-tab *ngIf="!fromOffer" [aria-labelledby]="tabIndex > 3 ? 'active' : null" [disabled]="true">
      <app-new-contract-sign
        *ngIf="tabIndex === 4"
        (changeLoader)="handleChangeLoader($event)"
        [idContract]="idContract"
        [codTraddingAccount]="dataOffer.codCuentaNegociadora"
        [dataForms]="dataForms"
        [fromOffer]="fromOffer"
      ></app-new-contract-sign>
    </mat-tab>
  </mat-tab-group>
  <app-new-contract-select-type
    *ngIf="tabIndex === 0"
    (canGoNext)="handleCanGoNextTab0($event)"
  ></app-new-contract-select-type>
</div>
